(function () {
  if (customElements.get('usp-bar-slider')) return;

  class UspBarSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-usp-slide]'));
      if (this.slides.length < 2) {
        if (this.slides[0]) this.slides[0].classList.add('is-active');
        return;
      }

      this.index = 0;
      this.intervalMs = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onMouseEnter = this.pause.bind(this);
      this.onMouseLeave = this.resume.bind(this);
      this.onFocusIn = this.pause.bind(this);
      this.onFocusOut = this.handleFocusOut.bind(this);
      this.onVisibility = this.handleVisibility.bind(this);

      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);

      if (typeof document !== 'undefined') {
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      this.show(0, false);
      this.resume();
    }

    disconnectedCallback() {
      this.pause();
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      if (typeof document !== 'undefined') {
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    }

    show(nextIndex, animate) {
      var current = this.slides[this.index];
      var next = this.slides[nextIndex];
      if (!next) return;

      if (current && current !== next) {
        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');
      }

      next.classList.add('is-active');
      next.setAttribute('aria-hidden', 'false');

      if (animate === false) {
        next.style.transition = 'none';
        requestAnimationFrame(
          function () {
            next.style.transition = '';
          }.bind(this)
        );
      }

      this.index = nextIndex;
    }

    next() {
      this.show((this.index + 1) % this.slides.length, true);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    resume() {
      if (this.timer || this.reducedMotion.matches || this.slides.length < 2) return;
      this.timer = setInterval(this.next.bind(this), this.intervalMs);
    }

    handleFocusOut(event) {
      if (!this.contains(event.relatedTarget)) this.resume();
    }

    handleVisibility() {
      if (document.hidden) {
        this.pause();
      } else {
        this.resume();
      }
    }
  }

  customElements.define('usp-bar-slider', UspBarSlider);
})();
